import axios from 'axios';
import { endpoints } from 'utils/global-constants';
/**
 * Get event data for an event in the Booking modal
 * @param {string} selectPerformance
 * @returns
 */
export const selectPerformance = async (performanceUrlParams) => {
  const requestUrl = `${endpoints.selectPerformance}?${performanceUrlParams}`;

  try {
    const response = await axios.get(requestUrl);
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

/**
 * Add promocode to Booking Modal
 * @param {object} applyPromocodePayload
 * @returns
 */
export const applyPromoCode = async (applyPromocodePayload) => {
  try {
    const response = await axios.post(endpoints.applyPromoCode, applyPromocodePayload);
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};

/**
 * Remove promocode from Booking Modal
 * @param {object} removePromocodePayload
 * @returns
 */
export const removePromoCode = async (removePromocodePayload) => {
  try {
    const response = await axios.post(endpoints.removePromoCode, removePromocodePayload);
    return response.data;
  } catch (e) {
    console.error(e);
    return null;
  }
};
